<template>
  <div
    v-if="hasValidQRCode"
    class="qrcode-wrapper"
    :class="{
      'fullscreen': isFullScreen,
      [`position-${posicaoEnquete}`]: true
    }"
  >
    <div class="qrcode-container">
      <img
        :src="item.enquete_qr_code.url"
        :alt="qrCodeAltText"
        class="qrcode-image"
        @error="onQRCodeError"
      />
    </div>
    <div class="participe-label">
      <span>Participe!</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTarjaEnqueteRedacaoSportvQRCODE',
  props: {
    item: {
      type: Object,
      default: () => null
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    posicaoEnquete: {
      type: String,
      default: 'esquerda'
    },
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || 'Participe da Enquete'}`;
    }
  },
  methods: {
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  }
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: "IndustryBlack";
  font-weight: 900;
  src: url("@/assets/fonts/RedacaoSportv/Industry-Black.ttf") format("truetype");
}

.qrcode-wrapper {
  --qrcode-border-color: #e63329;
  --participe-label-background: #e63329;
  --participe-label-text: #ffffff;

  position: fixed;
  bottom: 85px;
  left: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  max-width: none;
  margin: 0;
  transition: all 0.3s ease;
  z-index: 100;
  border: 12px solid var(--qrcode-border-color);
  background-color: #ffffff;
  height: 194px;

  &.fullscreen {
    max-width: 400px;
  }

  &.position-esquerda {
    align-self: flex-start;
  }

  &.position-direita {
    align-self: flex-end;
    left: auto;
    right: 60px;
  }

  &.position-centro {
    align-self: center;
    left: 50%;
    transform: translateX(-50%);
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  background-color: #ffffff;
}

.qrcode-image {
  width: 140px;
  height: 130px;
  object-fit: contain;
}

.participe-label {
  background: var(--participe-label-background);
  width: 100%;

  span {
    display: block;
    font-family: 'IndustryBlack', sans-serif;
    font-weight: 900;
    font-size: 20px;
    color: var(--participe-label-text);
    text-align: center;
  }
}
</style>
